export default function num2string(n, short = false) {
  if (n == undefined || !Number.isFinite(n)) return "";
  if (n < 1e3) return n.toLocaleString();

  const units = short
    ? ["k", "M", "B", "T"]
    : "thousand million billion trillion".split(" ");

  // Divide to get SI Unit engineering style numbers (1e3,1e6,1e9, etc)
  const unit = Math.floor((n.toFixed(0).length - 1) / 3) * 3;
  // Calculate the remainder
  const num = (n / `1e${unit}`).toFixed(2);
  const unitname = units[Math.floor(unit / 3) - 1];

  // output number remainder + unitname
  return `${num} ${unitname}`;
}
